export default {
  title: 'Edit ToDo',
  backButton: 'All ToDos',
};
